module.exports = __webpack_public_path__ + "img/reservar2.3dfdde59.png";